import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import EvolutionAdditionsSection from './EvolutionAdditionsSection';
import type { EvolutionRecord, EvolutionViewer } from '../../utils/evolutionRecordPolicy';

type Props = {
  open: boolean;
  onClose: () => void;
  evolution: EvolutionRecord & { id?: string; patient?: { full_name?: string; id?: string } };
  viewer: EvolutionViewer;
  professionalId: string | null;
  /** Contexto do painel/agenda quando a evolução no resumo não traz patient_id. */
  patientId?: string | null;
  onError?: (message: string) => void;
};

export default function EvolutionAdditionsDialog({
  open,
  onClose,
  evolution,
  viewer,
  professionalId,
  patientId: patientIdFromContext,
  onError,
}: Props) {
  const evolutionId = evolution?.id ? String(evolution.id) : null;
  const patientName = evolution?.patient?.full_name;
  const resolvedPatientId =
    String(patientIdFromContext || '').trim()
    || String((evolution as { patient_id?: string }).patient_id || '').trim()
    || String(evolution?.patient?.id || '').trim()
    || null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
      <DialogTitle sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2, pr: 1 }}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
            Informações adicionadas
          </Typography>
          {patientName ? (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.35 }}>
              {patientName}
            </Typography>
          ) : null}
        </Box>
        <IconButton aria-label="Fechar" onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ pt: 1 }}>
        <EvolutionAdditionsSection
          evolutionId={evolutionId}
          evolutionSnapshot={evolution}
          patientId={resolvedPatientId}
          viewer={viewer}
          professionalId={professionalId}
          onError={onError}
          variant="flat"
        />
      </DialogContent>
    </Dialog>
  );
}
